import styles from './ProsConsPane.module.css'
import clsx from 'clsx'
import ArrowBottomBird from 'shared-svg/ArrowBottomBird.svg'
import { BasicStyledComponent } from 'shared-definitions/types'

interface ProsConsPaneProps extends BasicStyledComponent {
  pros: string
  cons: string
  opened?: boolean
  onClick: () => void
}

const ProsConsPane: React.VFC<ProsConsPaneProps> = ({ className, onClick, pros, cons, opened }) => (
  <button type="button" className={clsx(styles.container, className)} onClick={onClick}>
    <span className={styles.pros}>
      {pros}
      <ArrowBottomBird className={clsx(styles.icon, { [styles.iconOpened]: opened })} />
    </span>
    {cons}
  </button>
)

export default ProsConsPane
